import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../elements/Button';
import { Checkbox, Flex, Stack, Text } from '@mantine/core';
import { change, Field } from 'redux-form';
import ImagePicker from '../../elements/ImagePicker';
import TextArea from '../../fields/TextArea';
import PropTypes from 'prop-types';
import { MIME_TYPES } from '@mantine/dropzone';

export const DEFAULT_VALUES = {
  file: [],
  agree: false,
  reason: '',
  type: 'accept'
};

const ProcessUnblockCustomerForm = (
  {
    handleSubmit = () => {},
    onCancel = () => {},
    type = 'accept',
    // change = () => {}
  }
) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState([]);
  const { values } = useSelector((state) =>
    state?.form?.FormProcessUnblockCustomer || { values: DEFAULT_VALUES });

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit({ ...values, file });
  };

  const wording = {
    'accept': 'menyetujui',
    'reject': 'menolak',
  };

  return (
    <form onSubmit={onSubmit}>
      <Stack>
        <Text c="#52575C" fz={18}>Apakah Anda yakin untuk {wording[type]} pengajuan pelanggan?</Text>
        <Field
          component={TextArea}
          helperText="Maksimal 300 karakter"
          inputProps={{
            label: `Alasan ${wording[type]} Pengajuan Pelanggan`,
          }}
          name="reason"
          onChange={(e) => change('FormProcessUnblockCustomer', 'reason', e.target.value)}
          required
        />
        <ImagePicker
          accept={[MIME_TYPES.pdf, MIME_TYPES.jpeg, MIME_TYPES.png]}
          info={'Format file .pdf atau foto dan tidak lebih dari 2 Mb'}
          maxSize={2000000}
          onSelect={setFile}
          title={'Dokumen Pendukung'}
        />
        <Field
          component={Checkbox}
          label={`Saya yakin untuk ${wording[type]} pengajuan pelanggan ini`}
          name="agree"
          onClick={(e) => dispatch(change('FormProcessUnblockCustomer', 'agree', e.target.checked))}
          styles={{
            body: {
              alignItems: 'center'
            },
            label: {
              color: '#212121',
              fontWeight: 400,
              fontSize: '14px'
            }
          }}
        />
        <Flex align="center" gap="sm" mt="md">
          <Button fullWidth onClick={onCancel} outlined>Batal</Button>
          <Button disabled={!values?.agree || !values?.reason} fullWidth style={type === 'accept' ? 'default' : 'danger'} type="submit" >{type === 'accept' ? 'Setujui' : 'Tolak'} Pengajuan</Button>
        </Flex>
      </Stack>
    </form>
  );
};

export default ProcessUnblockCustomerForm;

ProcessUnblockCustomerForm.propTypes = {
  // change: PropTypes.func,
  handleSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  type: PropTypes.oneOf(['accept', 'reject']),
};
